import React from "react";

const Maps = () => {
  return (
    <div className="maps">
      <div className="maps-header">
        <div className="maps-header-left">
          <p className="maps-heading">REACHING SURYA VILAS PALACE</p>
        </div>
        <div className="maps-header-right">
          <p className="maps-text">BY AIR</p>
          <img className="maps-plus" src="/Assets/plus.webp" alt="+"></img>
          <p className="maps-text">BY CAR</p>
          <img className="maps-plus" src="/Assets/plus.webp" alt="+"></img>
          <p className="maps-text">BY TRAIN</p>
          <img
            className="maps-plus"
            loading="lazy"
            src="/Assets/plus.webp"
            alt="+"
          ></img>
        </div>
      </div>
      <img
        className="maps-map"
        loading="lazy"
        src="/Assets/map.webp"
        alt="maps"
      ></img>
    </div>
  );
};

export default Maps;
